import React from 'react';

import { useViewModel } from './useViewModel';

import styles from './gwp-footer.module.css';

/**
 * Simplified GWP Footer: shows a single primary action.
 *
 * @param {Object} props
 * @param {() => void} props.onNext
 * @param {() => void} props.onClose
 * @param {boolean} props.isActionEnabled
 * @param {boolean} props.showAction
 * @returns {import('react').JSX.Element}
 */
export function GwpFooter(props) {
  const { handleNext, isActionEnabled, onClose, showAction } = useViewModel(props);

  return (
    <div className={styles['personalisation__footer']}>
      <div className={styles['personalisation__footer-inner'] + ' ' + styles['personalisation__footer-actions']}>
        {showAction ? (
          <button
            className={styles['personalisation__footer-continue'] + ' button button--primary button--orange'}
            onClick={handleNext}
            disabled={!isActionEnabled}
            title={!isActionEnabled ? 'Please select a gift option to continue' : ''}
          >
            Add to Bag
          </button>
        ) : (
          <div>&nbsp;</div>
        )}
        <button className={'button button--secondary button--black'} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
